import ReactDOM from 'react-dom';
import CompanyMenuItem from '../CompanyMenuItem';
import { DropDownProps } from './DropDown.props';
import { classes, DropdownPaper } from './DropDown.styles';

const DropDown = ({ handleDropDown, dropDownRef, subMenuItem, open }: DropDownProps) => {
  if (!open) {
    return null;
  }

  return ReactDOM.createPortal(
    <DropdownPaper
      className={classes.dropdown}
      elevation={7}
      id="company-dropdown"
      ref={dropDownRef as React.RefObject<HTMLDivElement>}
      square>
      {subMenuItem?.subMenu?.map(option => (
        <CompanyMenuItem key={option.id} handleDropDown={handleDropDown} option={option} subMenuItem={subMenuItem} />
      ))}
    </DropdownPaper>,
    document.body
  );
};

export default DropDown;
